module.exports = __webpack_public_path__ + "img/Roboto-Black.9c4bede.svg";